<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import * as echarts from 'echarts'
// require('echarts/theme/macarons') // echarts theme
import resize from './mixins/resize'

const animationDuration = 3000

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '620px'
    },
    charData: {
      type: Object,
      default() {
        return {
          timesX: [],
          payAmountY: [],
          disAmountY: [],
          payNumberY: [],
          disNumberY: []
        }
      }
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    charData() {
      this.$nextTick(() => {
        this.initChart()
      })
    }
  },
  mounted() {

  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el)
      this.chart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'cross' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          // data: ['pageA', 'pageB'],
          top: 30,
          bottom: 30,
          left: 30,
          right: 30,
          itemGap: 24,
          itemWidth: 16,
          itemHeight: 16
        },
        grid: {
          top: 100,
          left: '5%',
          right: '5%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: this.charData.timesX,
          axisTick: {
            alignWithLabel: true
          }
        }],
        yAxis: [
          {
            type: 'value',
            name: this.charData.config['yAxisName'],
            // min: 0,
            // max: 25,
            position: 'left',
            axisLine: {
              show: true,
              lineStyle: {
                color: '#98A1B4'
              }
            },
            axisTick: {
              show: true
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#D3D7DF'
              }
            },
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: [
          {
            name: this.charData.config['seriesName'][0],
            type: 'line',
            yAxisIndex: 0,
            color: '#1D3A71',
            data: this.charData.payY,
            animationDuration
          }, {
            name: this.charData.config['seriesName'][1],
            type: 'line',
            color: '#E2211C',
            yAxisIndex: 0,
            data: this.charData.disY,
            animationDuration
          }
          // {
          //   name: this.charData.config['seriesName'][2],
          //   type: 'line',
          //   color: '#3855F1',
          //   yAxisIndex: 0,
          //   data: this.charData.allY,
          //   animationDuration
          // }
        ]
      })
    }
  }
}
</script>
<style scoped>
@media screen and (max-width: 376px) {
  .chart{
      width: 700px !important;
  }
}
</style>
